'use client'

import "./globals.css";
import "./animations.css"
import localFont from "next/font/local";
import { Provider } from 'react-redux';
import store from '@/store/store';
import LayoutContent from "./LayoutContent";
import { useEffect } from "react";
import { printConsoleMessage } from "@/actions/utils/consoleMessage";

const iBrand = localFont({
  src: [
    {
      path: '../public/fonts/Ibrand.ttf',
      style: 'normal'
    }
  ],
  variable: '--font-ibrand'
});



export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {

  useEffect(() => {
    printConsoleMessage();
  }, []);

  return (
    <html lang="en">
      <head>

        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />


        <meta httpEquiv="Cross-Origin-Opener-Policy" content="same-origin-allow-popups" />
        <meta httpEquiv="Cross-Origin-Embedder-Policy" content="require-corp" />



        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </head>

      <body className={`${iBrand.className}`}>
        <Provider store={store}>
          <LayoutContent>
            {children}
           
          </LayoutContent>
        </Provider>
      </body>
    </html>
  );
}
